import PersonalArea from './PersonalArea';
import Catalog from './Catalog';
import Category from './Category';
import Orders from './Orders';
import OrderDetails from './OrderDetails';
import Favorites from './Favorites';
import Discounts from './Discounts';
import ProfileData from './ProfileData';
import Tech from './Tech';
import Instructions from './Instructions';
import Instruction from './Instruction';
import Loyalty from './Loyalty';
import Product from './Product';
import Cart from './Cart';

import { PersonalLoc } from '../../loc/personal';
import { loc } from '../../lib/loc';

export const TITLE = {
    '/': loc(PersonalLoc.menu.personalArea),
    '/catalog': loc(PersonalLoc.menu.catalog),
    '/orders/': loc(PersonalLoc.menu.orders),
    '/favorites/': loc(PersonalLoc.menu.favorites),
    '/discounts/': loc(PersonalLoc.menu.sales),
    '/profile/': loc(PersonalLoc.menu.profile),
    '/tech/': loc(PersonalLoc.menu.tech),
    '/instructions/': loc(PersonalLoc.menu.instructions),
    '/loyalty': 'Программа лояльности',
    '/cart': 'Корзина',
};

export default {
    PersonalArea,
    Catalog,
    Category,
    Orders,
    DetailOrder: OrderDetails,
    Favorites,
    Discounts,
    Profile: ProfileData,
    Tech,
    Instructions,
    Instruction,
    Loyalty,
    Product,
    Cart,
};
